import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { SectionHeading } from '../components/ui/SectionHeading';
import { PackageCard } from '../components/shared/PackageCard';
import { GiftCardVisual } from '../components/shared/GiftCardVisual';
import { packages } from '../data/packages';
import { IMAGES } from '../data/images';
import { BOOKING_URL } from '../data/site';
export function Packages() {
  return <>
      <Seo title="Training Packages & Gift Certificates" description="Save on Las Vegas CCW and defensive firearms training with course packages. Gift certificates for any course or package." data-id="element-886" data-mp="2q2n3kyuiczs" />
      <PageHero title="Packages & Gift Certificates" sub="Commit to your training path and save. Every package follows our recommended course sequence." image={IMAGES.students} crumbs={[{
      label: 'Packages & Gift Cards'
    }]} data-id="element-887" data-mp="1x43tqs0n04af">
        <ButtonLink href="#packages" size="lg" data-id="element-888" data-mp="4i9z0g4cntpl">
          Compare Packages
        </ButtonLink>
        <ButtonLink href="#gift" size="lg" variant="outline-light" data-id="element-889" data-mp="hq4lkb5v475">
          Gift Certificates
        </ButtonLink>
      </PageHero>

      <section id="packages" className="gutter section scroll-mt-24 bg-mist" aria-labelledby="pkg-title" data-id="element-890" data-mp="9ajnrstqanqa">
        <SectionHeading id="pkg-title" title="Compare Packages 1–8" data-id="element-891" data-mp="3hqd1jzwodl3n" />
        <p className="mt-6 flex items-center gap-2 text-sm text-steel" data-id="element-892" data-mp="3hqmtht1a62bz">
          <InfoIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-893" data-mp="3dq2yow46jat0" /> Packages apply to group courses, not private sessions.
        </p>
        <ul className="mt-10 grid gap-5 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4" data-id="element-894" data-mp="3rm6e3jae9elf">
          {packages.map(p => <li key={p.id} data-id="element-895" data-mp="16y1vr1fkflt8">
              <PackageCard pkg={p} data-id="element-896" data-mp="16x8z4tabmcot" />
            </li>)}
        </ul>
      </section>

      <section id="gift" className="gutter section scroll-mt-24 bg-ink" aria-labelledby="gift-title" data-id="element-897" data-mp="11y5q6xr7zmbk">
        <div className="grid items-center gap-14 lg:grid-cols-2" data-id="element-898" data-mp="19yvad7bjge7g">
          <GiftCardVisual className="max-w-[44rem]" data-id="element-899" data-mp="1e18czmuznw00" />
          <div data-id="element-900" data-mp="1dzxarrh6ywb0">
            <h2 id="gift-title" className="t-h2 text-white" data-id="element-901" data-mp="1e3l3ioetbeoo">Give the Gift of Self-Defense.</h2>
            <span className="red-rule mt-5" aria-hidden="true" data-id="element-902" data-mp="1iyic5u86jm11" />
            <p className="t-lead mt-6 max-w-[40rem] text-chrome-100" data-id="element-903" data-mp="1nymulpsneqtw">
              Gift certificates can be used for any course or package — a CCW permit class, a women-only course, or a full training path. Delivered instantly by email, ready to print.
            </p>
            <ul className="mt-6 space-y-2 text-chrome-300" data-id="element-904" data-mp="10adacsb32b4v">
              <li data-id="element-905" data-mp="1080lrwatl2iu">Any amount, any course or package</li>
              <li data-id="element-906" data-mp="1513g46nf8g03">Recipient picks the date that works for them</li>
              <li data-id="element-907" data-mp="7lfu0uqfmoer">Perfect for birthdays, holidays and new gun owners</li>
            </ul>
            <div className="mt-8" data-id="element-908" data-mp="7jlj898vkcoe">
              <ButtonLink href={BOOKING_URL} size="lg" data-id="element-909" data-mp="cjr5tb0af8zm">
                Buy a Gift Certificate
              </ButtonLink>
            </div>
          </div>
        </div>
      </section>
    </>;
}